/**
 * Mounts the assistant's single access probe (`useAgentAccess`) once for the
 * whole authenticated app, so `AgentPanel` and every "AI suggestions"
 * button (`useAgentAvailable`) share one `agentAccess` query instead of each
 * firing its own — mounted next to `AgentPanel` in `main-routes/Routes.tsx`.
 */
import React from "react";
import { useAgentAccess, type AgentAccess } from "./useAgentAccess.js";

const NO_ACCESS: AgentAccess = { enabled: false, speech: false };

const AgentAccessContext = React.createContext<AgentAccess>(NO_ACCESS);

export function AgentAccessProvider({ children }: React.PropsWithChildren<{}>) {
  const access = useAgentAccess();
  return (
    <AgentAccessContext.Provider value={access}>
      {children}
    </AgentAccessContext.Provider>
  );
}

/** The shared probe's current answer — `{ enabled: false, speech: false }` without a provider mounted above. */
export function useAgentAccessContext(): AgentAccess {
  return React.useContext(AgentAccessContext);
}
